import styled from 'styled-components';

export const Page = styled.div``;

export const Header = styled.section`
  max-width: ${({ theme }) => theme.container};
  margin: 24px auto 0;
  padding: 0 16px;
  h1{ color: ${({ theme }) => theme.colors.green[700]}; margin: 0 0 10px; }
`;

export const Section = styled.section`
  max-width: ${({ theme }) => theme.container};
  margin: 24px auto 0;
  padding: 0 16px;
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 20px;

  @media (max-width: 900px){ grid-template-columns: 1fr; }
`;

export const ImageWrap = styled.div`
  background: ${({ theme }) => theme.colors.gray[100]};
  border: 1px solid ${({ theme }) => theme.colors.gray[200]};
  border-radius: 12px;
  overflow: hidden;
  min-height: 220px;
  img{ width: 100%; height: 100%; object-fit: cover; display: block; }
`;

export const Content = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.gray[200]};
  border-radius: 12px;
  padding: 18px;
  h3 { margin: 0 0 6px; color: ${({ theme }) => theme.colors.green[700]}; }
  p { margin: 0; }
  ul {
    margin: 0;
    padding-left: 20px;
    list-style: disc;
  }
  li {
    margin-bottom: 4px;
  }
`;
